export default "__VITE_ASSET__0c3qFq0o__"